/**
 * Object Deleted Event Component
 *
 * Handles ahoy_object_deleted events.
 * Display pattern: "**Actor** deleted this contact"
 */

import { formatFallback } from '@/lib/crm/utils/labelFormatters';

import { ActorName, InlineText, TimelineEvent } from '../components/shared';
import { useEventFormatters } from '../useEventFormatters';
import type { EventComponentProps } from './types';

export function ObjectDeletedEvent({ event, entityType }: EventComponentProps) {
  const { getActorInfo } = useEventFormatters();
  const actor = getActorInfo(event);

  // Format entity type for display (e.g., "ahoy_contact" → "Contact")
  // Strip _entity suffix before formatting to avoid "Contact Entity" → use "Contact"
  const typeWithoutSuffix = entityType.replace(/_entity$/, '');
  const entityTypeLabel = formatFallback(typeWithoutSuffix).toLowerCase();
  const ariaLabel = `${actor.name} deleted this ${entityTypeLabel}`;

  return (
    <TimelineEvent ariaLabel={ariaLabel}>
      <TimelineEvent.Icon event={event} />
      <TimelineEvent.Header timestamp={event.occurred_at}>
        <InlineText>
          <ActorName actor={actor} /> deleted this {entityTypeLabel}
        </InlineText>
      </TimelineEvent.Header>
    </TimelineEvent>
  );
}
